<template>
  <div class="prm-list" v-loading="pageloading">
    <main-head>
      <template v-slot:pageName>
        {{ $t('page.drafts') }}
      </template>
      <!-- <template v-slot:headBtn>
        <el-button type="primary" v-if="isChannelRole===true&&
          !btnSet.includes('btn_prm_create')" size="medium" @click="toAdd"
        >
          {{ $t('page.addProject') }}
        </el-button>
      </template> -->
    </main-head>
    <main-content>
      <template v-slot:contentArea>
        <div class="form">
          <el-form ref="form" :model="form" label-width="185px">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmList.projectName')">
                  <el-input v-model="form.projectName" :placeholder="$t('message.needProjectName')" maxlength="256" @blur="getList(form.projectName,'projectName')" />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="false">
                <el-form-item :label="$t('page.prmList.partnerName')">
                  <el-input v-model="form.partnerName" :placeholder="$t('message.needPartnerName')" maxlength="256" @blur="getList(form.partnerName,'partnerName')" />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="false">
                <el-form-item :label="$t('page.prmList.country')">
                  <el-select style="width: 100%" v-model="form.nation" clearable filterable
                             :placeholder="$t('message.select')"
                  >
                    <el-option v-for="item in AllCountries"
                               :value="item.areaCode"
                               :key="item.areaCode"
                               :label="item.areaName"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmList.ruijieSaleName')">
                  <el-input v-model="form.ruijieSaleName" :placeholder="$t('message.needRuijieSaleName1')" maxlength="256" @blur="getList(form.ruijieSaleName,'ruijieSaleName')" />
                </el-form-item>
              </el-col>
              <el-col :span="20" style="text-align: center;">
                <el-button v-if="!btnSet.includes('btn_prm_search')" type="primary" size="medium" class="submit" @click="search" plain>{{ $t('common.search') }}</el-button>
                <el-button v-if="!btnSet.includes('btn_prm_search')" class="cancle" size="medium" plain @click="registe">{{ $t("common.reset") }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table">
          <el-table :data="tabledata" border style="width: 100%;font-size: 14px">
            <el-table-column prop="projectName" align="center" :label="$t('page.prmList.projectName')"
                             :render-header="fullHeader" show-overflow-tooltip
            />
            <el-table-column prop="partnerName" align="center" :label="$t('page.prmList.partnerName')"
                             :render-header="fullHeader" show-overflow-tooltip v-if="false"
            />
            <el-table-column prop="areaName" align="center" :render-header="fullHeader"
                             :label="$t('page.prmList.country')" width="120px" v-if="false"
            />
            <el-table-column prop="ruijieSaleName" align="center" :label="$t('page.prmList.ruijieSaleName')"
                             :render-header="fullHeader" show-overflow-tooltip
            />
            <el-table-column prop="createUserName" align="center" :label="$t('page.prmList.applicant')"
                             :render-header="fullHeader" show-overflow-tooltip v-if="false"
            />
            <el-table-column prop="createTime" align="center" :label="$t('page.prmList.submitTime')"
                             :render-header="fullHeader" show-overflow-tooltip v-if="false"
            >
              <template slot-scope="scope">
                {{ parseTime(scope.row.createTime,"{y}-{m}-{d}") }}
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" :label="$t('message.operation')" width="220px">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="goviewpage(scope.row)">{{ $t('common.view') }}</el-button>
                <!-- <el-button type="text" size="medium" @click="goeditpage(scope.row)">{{ $t('common.edit') }}</el-button>
                <el-button type="text" size="medium" @click="showDialog(scope.row)">{{ $t('common.delete') }}</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            :title="$t('message.hints')"
            :visible.sync="dialogVisible"
            width="30%"
          >
            <span>{{ $t("message.deleteConfirm") }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">{{ $t("message.cancel") }}</el-button>
              <el-button type="primary" @click="deleteprm()">{{ $t("message.comfirm") }}</el-button>
            </span>
          </el-dialog>

          <div class="paging" style="text-align: right;margin-top: 20px">
            <el-pagination background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="page.currentPage"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="page.pagesize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="page.total"
            />
          </div>
        </div>
        <div class="clear" />
      </template>
    </main-content>
  </div>
</template>

<script>
import API from '../../API';
import { formate } from '../../libs/mixin';
import mainHead from '../component/mainHead';
import mainContent from '../component/mainContent';
import { merge } from '../../libs/util';
import store from '../../store';
export default {
  name: 'PrmTodoList',
  mixins: [formate],
  data () {
    return {
      dialogVisible: false,
      starts: false,
      start: false,
      pageName: 'Drafts',
      tabledata: [],
      pageloading: false,
      page: {
        currentPage: 1,
        pagesize: 20,
        total: 0
      },
      form: {
        projectName: '',
        partnerName: '',
        ruijieSaleName: '',
        nation: '',
        approvalstate: ''
      },
      stepList: [],
      AllCountries: [],
      selectRow: '',
      isChannelRole: false,
      btnSet: []
    };
  },
  components: {
    mainHead,
    mainContent
  },
  methods: {
    getList (value, values) {
      // console.log(A);
      this.form[values] = value.trim();
    },
    toAdd () {
      this.$router.push({ name: 'prmNew' });
    },
    toDetail () {
      this.$router.push({ name: 'prmDtl' });
    },
    init () {
      API.getDepartments()
        .then((res) => {
          let json = res.data;
          // eslint-disable-next-line no-undef, eqeqeq
          if (json.data.indexOf('ebgDept') != -1) {
            this.starts = true;
            this.start = false;
          }
          // eslint-disable-next-line eqeqeq, no-undef
          if (json.data.indexOf('sbgDept') != -1) {
            this.start = true;
            this.starts = false;
          }
          // eslint-disable-next-line eqeqeq
          if (json.data == []) {
            this.start = false;
            this.starts = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      API.getAllCountries(this.$i18n.locale).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.AllCountries = json.data;
        }
      }).catch((e) => {
        console.log(e);
      });
      API.getAllSteps(this.$i18n.locale).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.stepList = json.data;
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    search () {
      this.pageloading = true;
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pagesize,
        projectName: this.form.projectName,
        partnerName: this.form.partnerName,
        ruijieSaleName: this.form.ruijieSaleName,
        areaCode: this.form.nation,
        language: this.$i18n.locale
      };
      API.getDrafts(params).then((res) => {
        this.pageloading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tabledata = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch((e) => {
        this.pageloading = false;
      });
    },
    handleSizeChange (val) {
      this.page.pagesize = val;
      this.search();
    },
    handleCurrentChange (val) {
      this.page.currentPage = val;
      this.search();
    },
    fullHeader (h, { column }) {
      if (column.label) {
        return (h('el-tooltip', {
          attrs: {
            class: 'item',
            effect: 'dark',
            content: column.label,
            placement: 'bottom'
          }
        }, [ h('span', [column.label]) ]));
      }
    },
    goviewpage (row) {
      let query = merge(this.$route.query, {
        objectId: row.id,
        start: this.start,
        starts: this.starts
      });
      // eslint-disable-next-line eqeqeq
      if (!(this.start || this.starts)) {
        this.$message.error(this.$t('message.setDepartment'));
      } else {
        this.$router.push({
          name: 'prmDtl',
          query: query
        });
      }
    },
    showDialog (row) {
      this.selectRow = row;
      this.dialogVisible = true;
    },
    deleteprm () {
      API.deleteDraft(this.selectRow.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify({
            title: this.$t('message.deletesuccess'),
            type: 'success'
          });
          this.search();
        }
      }).catch((e) => {
        console.log(e);
      });
      this.dialogVisible = false;
    },
    goeditpage (row) {
      let query = merge(this.$route.query, {
        objectId: row.id,
        isShow: true
      });
      if (!(this.start || this.starts)) {
        this.$message.error(this.$t('message.setDepartment'));
      } else if (this.starts) {
        this.$router.push({
          name: 'prmEditEBG',
          query: query
        });
      } else {
        this.$router.push({
          name: 'prmEdit',
          query: query
        });
      }
    },
    registe () {
      this.form = {
        projectName: '',
        partnerName: '',
        ruijieSaleName: '',
        nation: '',
        approvalstate: ''
      };
      this.page = {
        currentPage: 1,
        pagesize: 20,
        total: 0
      };
      this.search();
    },
    getCurUserRole () {
      API.getCurUserRole().then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.isChannelRole = json.data;
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
  mounted () {
    this.init();
    this.search();
    this.getCurUserRole();
    this.btnSet = store.state.UserBtnPermissionsData || [];
    // this.getAllPartnerUsers();
    // this.allFlow();
  }
};
</script>

<style lang="scss">
.prm-list{
  .form{
    .el-form-item__label{
      text-align: left;
    }
  }
  .table{
    margin-top: 10px;
  }
  .paging{
    margin-top: 20px;
    float: right;
  }
  .clear{
    clear: both;
  }
  .el-select{
    width: 100%;
  }
}
</style>
